/** @jsx jsx */

import { Colors, Link } from '@zapier/design-system';
import { css, jsx } from '@emotion/core';

type SkipLinkProps = {
  href?: string;
  text?: string;
};

const Styles = {
  root: css`
    color: ${Colors.gray80};
    display: block;
    fontSize: 10px;
    textTransform: uppercase;
    /* Hide the link and make it unclickable. */
    opacity: 0;
    pointerEvents: none;
    textDecoration: none;
    width: 0px;
    /* Only show the link on focus. */
    &:focus {
      opacity: 1;
      outline: none;
    },
  `,
};

const defaultProps = {
  href: '#mainContent',
  text: 'Skip to content',
};

function SkipLink({
  href = defaultProps.href,
  text = defaultProps.text,
}: SkipLinkProps) {
  return (
    <Link
      // Without the `main`, screen reader will read this as `Skip to conTENT`
      ariaLabel="Skip to main content"
      css={Styles.root}
      href={href}
    >
      {text}
    </Link>
  );
}

SkipLink.defaultProps = defaultProps;

export default SkipLink;
